export default (props, vars) =>
  `https://cdn.paragonone.com/files/social-media/${vars?.['defaultUseParams3']?.['image']}_seo.png`;
